import { QueryClient } from '@tanstack/react-query';
import { loginRoute, newPassword, notFound } from 'routes/routes';
import { isHttpStatus } from 'utils/httpError';

// This will retry on 401 errors 5 times rest of the time we do not retry on any other error.
// The status is read through the shared helper rather than string-matching the message, so this
// and use404Redirect give the same answer to "what status was this" for the same error.
const retry = (failureCount: number, error: unknown) => {
  if (failureCount < 5 && !noRetryRoutes.includes(location.pathname) && isHttpStatus(error, 401)) {
    return true;
  }
  return false;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: retry,
    },
    mutations: {
      retry: retry,
    },
  },
});

const noRetryRoutes = [loginRoute, newPassword, notFound];
